import { render, staticRenderFns } from "./yo-whatsapp.vue?vue&type=template&id=357ac414&scoped=true"
import script from "./yo-whatsapp.vue?vue&type=script&lang=js"
export * from "./yo-whatsapp.vue?vue&type=script&lang=js"
import style0 from "./yo-whatsapp.vue?vue&type=style&index=0&id=357ac414&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357ac414",
  null
  
)

export default component.exports